import styled from 'styled-components/macro';

// UI Kit Card
export const UIKitCardWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: fit-content;
  border-radius: 8px;
  border-width: 1px;
  background: ${props => props.theme.colors.white[100]};
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 247px;
  height: 88px;
  box-sizing: border-box;
  border-radius: 8px;
  border-width: 1px;
  background: ${props => props.theme.colors.neutral[20]};
  border: 1px solid ${props => props.theme.colors.neutral[20]};
`;

export const UIKitCardTitle = styled.div`
  font-family: Work Sans;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.neutral[100]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColorBox = styled.div<{ color: string }>`
  width: 34px;
  height: 34px;
  border-radius: 4px;
  border-width: 1px;
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  background-color: ${({ color }) => color};
`;
export const FontFamily = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.neutral[100]};
`;
export const FontSize = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.neutral[80]};
`;

// UI Kit Card Section
export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${props => props.theme.colors.secondary[5]};
`;

export const UIKitCardSectionTitle = styled.h3`
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 4%;
  text-transform: uppercase;
  color: ${props => props.theme.colors.secondary[40]};
  margin: 0;
`;
